import { useQuery } from '@tanstack/react-query';

import { useAppState } from '../../AppStateProvider';

import quotaApi from './api';
import { quotaQueryKeys } from './queryKeys';

export const useExportQuotaQuery = (isEnabled = true) => {
  const { isOpen } = useAppState();

  return useQuery({
    enabled: isOpen && isEnabled,
    queryKey: quotaQueryKeys.exportQuota(),
    queryFn: ({ signal }) => {
      return quotaApi.getExportQuota(signal);
    },
  });
};
